import ratioUtils from 'Components/utils/ratios/ratios.utils';

export const cardMediaThemes = {
  default: {
    thImage: '',
    thImageRatio: ratioUtils.M,
    thVideo: 'bg-black',
  },
  destination: {
    thImage: '',
    thImageRatio: ratioUtils.M,
    thVideo: 'bg-black',
  },
  landing: {
    thImage: '',
    thImageRatio: ratioUtils.R_38_BY_58,
    thVideo: 'bg-black',
  },
  thumbnail: {
    thImage: '',
    thImageRatio: ratioUtils.M,
    thVideo: 'bg-black',
  },
};
